import * as ng from 'angular';
import {ArchiSmallServices} from './services/archismall.service';
import {IAppConstants} from './app.constants';
import {
  TransitionService, Trace, Transition
} from '@uirouter/core';
import {IUser} from './commons/interfaces/user/user';

export const appRun: ng.Injectable<Function> = (
  $rootScope: any,
  $state: ng.ui.IStateService,
  $stateParams: ng.ui.IStateParamsService,
  store: ng.a0.storage.IStoreService,
  jwtHelper: ng.jwt.IJwtHelper,
  ArchiSmallServices: ArchiSmallServices,
  configuration: IAppConstants,
  $uibModal: ng.ui.bootstrap.IModalService,
  $timeout: ng.ITimeoutService,
  $anchorScroll: ng.IAnchorScrollService,
  $transitions: TransitionService,
  $trace: Trace
) => {
  $trace.enable('TRANSITION');
  $rootScope.$state = $state;
  $rootScope.showMaintenanceAlert = false;
  $rootScope.accepted = false;
  $rootScope.$stateParams = $stateParams;
  $rootScope.archiSmallAppVersion = configuration.archiSmallAppVersion;
  $rootScope.workerNameSuffix = configuration.workerNameSuffix;
  $rootScope.fatturaPAAttachmentMaxSize = configuration.fatturaPAAttachmentMaxSize;
  $rootScope.archidriveArchives = [];
  $rootScope.conservazioneArchives = [];

  $rootScope.checkIfCanUseFatturazione = (transition, nextPage, user) => {
    let canUseFatturaPA = user.canUseFatturaPA && (user.organizationData.regimeFiscale !== '' ||
      user.organizationData.inscrizioneREA.ufficio !== '' ||
      user.organizationData.inscrizioneREA.numeroREA !== '' ||
      user.organizationData.inscrizioneREA.socioUnico !== '' ||
      user.organizationData.inscrizioneREA.statoLiquidazione !== '');
    let state = '';
    if ((!canUseFatturaPA && nextPage.name !== 'home.request-information-fattura-pa') && !user.subscription.readOnly) {
      state = 'home.request-information-fattura-pa';
    } else if (user.canUseFatturaPA && nextPage.name === 'home.request-information-fattura-pa') {
      state = 'home.index';
    }

    if (state !== '') {
      transition.abort();
      $state.go(state);
    }
  };
  $rootScope.checkIfCanUseFatturazioneLP = (transition, nextPage, user) => {
    let canUseFatturaPA = user.canUseFatturaPA && user.organizationData.regimeFiscale !== '';
    let state = '';
    if ((!canUseFatturaPA && nextPage.name !== 'home.request-information-fattura-pa-lp') && !user.subscription.readOnly) {
      state = 'home.request-information-fattura-pa-lp';
    } else if (user.canUseFatturaPA && nextPage.name === 'home.request-information-fattura-pa-lp') {
      state = 'home.index';
    }

    if (state !== '') {
      transition.abort();
      $state.go(state);
    }
  };
  $rootScope.checkIfCanUseConservazione = (transition, nextPage, user) => {
    let state = '';
    let canUseConservazione = (user.canUseConservazione && (user.organizationData.contactPerson.firstname !== '' ||
      user.organizationData.contactPerson.surname !== '' ||
      user.organizationData.contactPerson.fiscalCode !== '' ||
      user.organizationData.contactPerson.birthDate !== '' ||
      user.organizationData.contactPerson.birthCountry !== '' ||
      user.organizationData.contactPerson.birthProvince !== '' ||
      user.organizationData.contactPerson.birthCity !== ''));
    if ((nextPage.name !== 'home.request-information-conservazione' && !canUseConservazione) && !user.subscription.readOnly) {
      state = 'home.request-information-conservazione';
    } else if (nextPage.name === 'home.request-information-conservazione' && canUseConservazione) {
      state = 'home.index';
    }

    if (state !== '') {
      transition.abort();
      $state.go(state);
    }
  };
  $rootScope.checkIfCanUseFatturazioneAndConservazione = (transition: Transition, nextPage: any) => {
    let user = store.get('user');
    if (user.accountData.userType === 1) {
      if ([
        'home.fatturazione',
        'home.pa-componi-fattura',
        'home.pa-componi-fattura-confirm',
        'home.pa-componi-fattura-summary',
        'home.pa-componi-fattura-semplice',
        'home.pa-carica-fattura',
        'home.pa-carica-fattura-summary',
        'home.pa-visualizza-stato-fatture',
        'home.fatturazione-pa',
        'home.pr-componi-fattura-avanzata',
        'home.pr-componi-fattura-confirm',
        'home.componi-fattura-pr-summary',
        'home.componi-fattura-pr-semplice',
        'home.pr-carica-fattura',
        'home.carica-fattura-pr-summary',
        'home.visualizza-stato-fatture-pr',
        'home.pr-fattura-elettronica-passiva',
        'home.fatturazione-pr',
        'home.request-information-fattura-pa-lp'].indexOf(nextPage.name) > -1) {
        $rootScope.checkIfCanUseFatturazioneLP(transition, nextPage, user);
      }
    } else {
      if ([
        'home.fatturazione',
        'home.pa-componi-fattura',
        'home.pa-componi-fattura-confirm',
        'home.pa-componi-fattura-summary',
        'home.pa-componi-fattura-semplice',
        'home.pa-carica-fattura',
        'home.pa-carica-fattura-summary',
        'home.pa-visualizza-stato-fatture',
        'home.fatturazione-pa',
        'home.pr-componi-fattura-avanzata',
        'home.pr-componi-fattura-confirm',
        'home.componi-fattura-pr-summary',
        'home.componi-fattura-pr-semplice',
        'home.pr-carica-fattura',
        'home.carica-fattura-pr-summary',
        'home.visualizza-stato-fatture-pr',
        'home.pr-fattura-elettronica-passiva',
        'home.fatturazione-pr',
        'home.request-information-fattura-pa'].indexOf(nextPage.name) > -1) {
        $rootScope.checkIfCanUseFatturazione(transition, nextPage, user);
      } else if ([
        'home.conservazione',
        'home.conservazione-carica-documento-step1',
        'home.conservazione-carica-documento-libro-contabile-step2',
        'home.conservazione-carica-documento-registro-contabile-step2',
        'home.conservazione-carica-documento-modello-dichiarativo-step2',
        'home.conservazione-carica-documento-modello-versamento-step2',
        'home.conservazione-carica-documento-bollette-step2',
        'home.conservazione-carica-documento-altro-documento-step2',
        'home.conservazione-carica-documento-fattura-passiva-step2',
        'home.conservazione-carica-documento-ddt-attivo-step2',
        'home.conservazione-carica-documento-ddt-passivo-step2',
        'home.conservazione-carica-documento-lul-step2',
        'home.conservazione-carica-documento-step3',
        'home.conservazione-pacchetti-archiviazione',
        'home.verifica-documenti-caricati',
        'home.conservazione-consulta-documenti',
        'home.conservazione-fatture-attive-versamento-result',
        'home.request-information-conservazione',
        'home.conservazione-carica-documento-libro-giornale-step2',
        'home.conservazione-carica-documento-prima-nota-step2',
        'home.conservazione-carica-documento-giornali-schede-magazzino-step2',
        'home.conservazione-carica-documento-libro-inventari-step2',
        'home.conservazione-carica-documento-registro-omaggi-step2',
        'home.conservazione-carica-documento-libro-mastro-step2',
        'home.conservazione-carica-documento-libro-cespiti-step2',
        'home.conservazione-carica-documento-altri-libri-step2',
        'home.conservazione-carica-documento-registro-corrispettivi-iva-step2',
        'home.conservazione-carica-documento-dichiarazioni-fiscali-step2',
        'home.conservazione-carica-documento-ricevute-fiscali-step2',
        'home.conservazione-carica-documento-registro-beni-di-terzi-step2',
        'home.conservazione-carica-documento-registro-unico-iva-step2',
        'home.conservazione-carica-documento-libro-registri-iva-step2',
        'home.conservazione-carica-documento-giornali-schede-magazzino-step2',
        'home.conservazione-carica-documento-registro-riepilogativo-iva-step2',
        'home.conservazione-carica-documento-altri-registri-step2',
        'home.conservazione-carica-documento-registro-fatture-acquisto-step2',
        'home.conservazione-carica-documento-registro-fatture-vendita-step2',
        'home.conservazione-carica-documento-modello-f23-f24-step2',
        'home.conservazione-carica-documento-modello-770-step2',
        'home.conservazione-carica-documento-verbali-verifica-scarto-step2',
        'home.conservazione-carica-documento-nomine-deleghe-conservazione-step2',
        'home.conservazione-carica-documento-schede-cliniche-step2',
        'home.conservazione-carica-documento-ordini-a-fornitore-step2',
        'home.conservazione-carica-documento-ordini-da-cliente-step2',
        'home.conservazione-carica-documento-contratti-a-cliente-step2',
        'home.conservazione-carica-documento-contratti-da-fornitore-step2',
        'home.conservazione-carica-documento-registro-rifiuti-step2',
        'home.conservazione-carica-documento-modello-730-step2',
        'home.conservazione-carica-documento-documenti-bancari-step2',
        'home.conservazione-carica-documento-CM-step2',
        'home.conservazione-carica-documento-CMR-step2',
        'home.conservazione-carica-documento-formulario-identificativo-rifiuti-step2',
        'home.conservazione-carica-documento-dichiarazioni-intento-attive-step2',
        'home.conservazione-carica-documento-dichiarazioni-intento-passive-step2',
        'home.conservazione-carica-documento-documenti-doganali-emessi-step2',
        'home.conservazione-carica-documento-documenti-doganali-ricevuti-step2',
        'home.conservazione-carica-documento-modello-intrastat-step2',  
        'home.conservazione-carica-documento-libri-sociali-step2',
        'home.conservazione-carica-documento-registro-liquidazioni-iva-step2',
        'home.conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2',
        'home.conservazione-carica-documento-note-spese-e-trasferte-step2',
        'home.conservazione-carica-documento-POD-step2',
        'home.conservazione-carica-documento-bilanci-step2'
      ].indexOf(nextPage.name) > -1) {
        $rootScope.checkIfCanUseConservazione(transition, nextPage, user);
      }
    }
  };

  $rootScope.checkIfCanUseFatturaPrivati = (transition: Transition, nextPage: any) => {
    if ([
      'home.fatturazione-pr',
      'home.pr-componi-fattura-avanzata',
      'home.pr-componi-fattura-confirm',
      'home.componi-fattura-pr-summary',
      'home.componi-fattura-pr-semplice',
      'home.pr-carica-fattura',
      'home.carica-fattura-pr-summary',
      'home.visualizza-stato-fatture-pr',
      'home.pr-fattura-elettronica-passiva',
      'home.request-codice-destinatario-fattura-pr'
    ].indexOf(nextPage.name) > -1) {

      let user = store.get('user');
      let state = '';
      let codiceDestinatarioIsMissing = user.organizationData.codiceDestinatario === '' ||
        user.organizationData.codiceDestinatario === undefined;

      if ((codiceDestinatarioIsMissing && nextPage.name !== 'home.request-codice-destinatario-fattura-pr') && !user.subscription.readOnly) {
        state = 'home.request-codice-destinatario-fattura-pr';
      } else if (!codiceDestinatarioIsMissing && nextPage.name === 'home.request-codice-destinatario-fattura-pr') {
        state = 'home.index';
      }

      if (state !== '') {
        transition.abort();
        $state.go(state);
      }
    }
  };

  $rootScope.goToUnsubscriptionSectionIfSubscriptionCancelled = (transition: Transition, nextPage: any) => {
    if (store.get('user') === undefined || store.get('user').length === 0) {
      $rootScope.signOut();
    }
    if ($rootScope.subscriptionCancelled || store.get('user').subscription.subscriptionCancelled) {
      if ([
          'unsubscription.unsubscription-index',
          'unsubscription.scarica-archivio',
          'unsubscription.scarica-documenti-conservati',
          'unsubscription.renew-subscription',
          'unsubscription.renew-subscription-summary',
          'login'
        ].indexOf(nextPage.name) === -1 &&
        (!$rootScope.checkIfSubscriptionIsExpired())
      ) {
        transition.abort();
        $state.go('unsubscription.unsubscription-index');
      }
    } else {
      if ([
        'unsubscription.unsubscription-index',
        'unsubscription.scarica-archivio',
        'unsubscription.scarica-documenti-conservati',
        'unsubscription.renew-subscription',
        'unsubscription.renew-subscription-summary'
      ].indexOf(nextPage.name) > -1) {
        transition.abort();
        $state.go('home.home-index');
      }
    }
  };

  $rootScope.goToSubscriptionExpirationIfExpired = (transition: Transition, nextPage: any) => {
    if ($rootScope.subscriptionExpired !== 'undefined' && $rootScope.subscriptionExpired || store.get('user').disabled) {
      if (nextPage.name !== 'unsubscription.abbonamento-disdetto' &&
        nextPage.name !== 'login') {
        transition.abort();
        $state.go('unsubscription.abbonamento-disdetto');
      }
    }
  };

  $rootScope.checkIfSubscriptionIsExpired = () => {
    let isExpired: boolean = false;
    if ($rootScope.subscriptionExpired === 'undefined') {
      if (store.get('user').disabled !== 'undefined') {
        isExpired = store.get('user').disabled;
      }
    } else {
      isExpired = $rootScope.subscriptionExpired || store.get('user').disabled;
    }
    return isExpired;
  };

  $rootScope.removeConservazioneSettingsFiles = (classeDocumentale) => {
    ArchiSmallServices.deleteConservazioneSettings(classeDocumentale).then(
      (response: ng.IHttpResponse<any>) => {
        if (response !== undefined) {
          $rootScope.readyToUse = true;
        }
      },
      (reason: any) => {
        $rootScope.alert('error', reason);
      }
    );
  };

  $rootScope.showConfirmationAlertIfStep2 = (transition: Transition, nextPage: any) => {
    let isConservazioneCaricaStep2 = $rootScope.checkIfConservazioneCaricaStep2();

    if (isConservazioneCaricaStep2 && !($rootScope.subscriptionCancelled || store.get('user').subscription.subscriptionCancelled)) { // && !$rootScope.accepted
      return $rootScope.showConfirmationAlertIfSettingsExist(transition, nextPage);
    }

    return false;
  };

  $rootScope.checkIfConservazioneCaricaStep2 = () => {
    return [
      'home.conservazione-carica-documento-libro-contabile-step2',
      'home.conservazione-carica-documento-registro-contabile-step2',
      'home.conservazione-carica-documento-modello-dichiarativo-step2',
      'home.conservazione-carica-documento-modello-versamento-step2',
      'home.conservazione-carica-documento-bollette-step2',
      'home.conservazione-carica-documento-altro-documento-step2',
      'home.conservazione-carica-documento-fattura-passiva-step2',
      'home.conservazione-carica-documento-ddt-attivo-step2',
      'home.conservazione-carica-documento-ddt-passivo-step2',
      'home.conservazione-carica-documento-lul-step2',
      'home.conservazione-carica-documento-libro-giornale-step2',
      'home.conservazione-carica-documento-prima-nota-step2',
      'home.conservazione-carica-documento-giornali-schede-magazzino-step2',
      'home.conservazione-carica-documento-libro-inventari-step2',
      'home.conservazione-carica-documento-registro-omaggi-step2',
      'home.conservazione-carica-documento-libro-mastro-step2',
      'home.conservazione-carica-documento-libro-cespiti-step2',
      'home.conservazione-carica-documento-altri-libri-step2',
      'home.conservazione-carica-documento-registro-corrispettivi-iva-step2',
      'home.conservazione-carica-documento-dichiarazioni-fiscali-step2',
      'home.conservazione-carica-documento-ricevute-fiscali-step2',
      'home.conservazione-carica-documento-registro-beni-di-terzi-step2',
      'home.conservazione-carica-documento-registro-unico-iva-step2',
      'home.conservazione-carica-documento-libro-registri-iva-step2',
      'home.conservazione-carica-documento-giornali-schede-magazzino-step2',
      'home.conservazione-carica-documento-registro-riepilogativo-iva-step2',
      'home.conservazione-carica-documento-altri-registri-step2',
      'home.conservazione-carica-documento-registro-fatture-acquisto-step2',
      'home.conservazione-carica-documento-registro-fatture-vendita-step2',
      'home.conservazione-carica-documento-modello-f23-f24-step2',
      'home.conservazione-carica-documento-modello-770-step2',
      'home.conservazione-carica-documento-verbali-verifica-scarto-step2',
      'home.conservazione-carica-documento-nomine-deleghe-conservazione-step2',
      'home.conservazione-carica-documento-schede-cliniche-step2',
      'home.conservazione-carica-documento-ordini-a-fornitore-step2',
      'home.conservazione-carica-documento-ordini-da-cliente-step2',
      'home.conservazione-carica-documento-contratti-a-cliente-step2',
      'home.conservazione-carica-documento-contratti-da-fornitore-step2',
      'home.conservazione-carica-documento-registro-rifiuti-step2',
      'home.conservazione-carica-documento-modello-730-step2',
      'home.conservazione-carica-documento-documenti-bancari-step2',
      'home.conservazione-carica-documento-CM-step2',
      'home.conservazione-carica-documento-CMR-step2',
      'home.conservazione-carica-documento-formulario-identificativo-rifiuti-step2',
      'home.conservazione-carica-documento-dichiarazioni-intento-attive-step2',
      'home.conservazione-carica-documento-dichiarazioni-intento-passive-step2',
      'home.conservazione-carica-documento-documenti-doganali-emessi-step2',
      'home.conservazione-carica-documento-documenti-doganali-ricevuti-step2',
      'home.conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2',
      'home.conservazione-carica-documento-note-spese-e-trasferte-step2',
      'home.conservazione-carica-documento-POD-step2',
      'home.conservazione-carica-documento-bilanci-step2'
    ].indexOf($state.current.name) > -1;
  };

  let isVerificaDocumentiState = () => {
    return $state.current.name === 'home.verifica-documenti-caricati';
  };

  let verificaDocumentiModalInstantiation = (state: any, transition?: Transition, nextPage?: any) => {
    if (transition) {
      transition.abort();
    }

    let modalInstance = $uibModal.open({
      animation: true,
      component: 'defaultModalComponent',
      windowClass: 'center-modal',
      resolve: {
        config: () => {
          return {
            headerIcon: 'fa fa-exclamation-triangle',
            headerText: 'Attenzione',
            bodyHtml: `
                            Desideri interrompere l’operazione di Conservazione Mail/PEC??<br/>
                            <br/>Se selezioni <b>Si</b>, confermi l’uscita dalla procedura e annulli l’operazione in corso.<br/>
                            In questo caso i documenti caricati <b>dovranno essere verificati</b>
                            nella sezione <b>Consulta Documenti.</b><br/> <br/>
                            Seleziona <b>No</b> per proseguire con la Conservazione.
                        `,
            buttons: [
              {
                'id': 1,
                'icon': 'fa fa-times-circle-o',
                'label': 'No'
              },
              {
                'id': 2,
                'icon': 'fa fa-check-circle-o',
                'label': 'Si'
              }
            ]
          };
        }
      }
    });
    modalInstance.result.then((pressedButtonId: number) => {
      if (pressedButtonId === 1) {
        $rootScope.accepted = false;
        if (typeof transition !== 'undefined') {
          transition.abort();
        }
      } else if (pressedButtonId === 2) {
        $rootScope.accepted = true;

        $timeout(() => {
          if (nextPage && state === 'logout') {
            $rootScope.signOut();
            return;
          }
          $state.go(nextPage.name);
        });
      }
    });
  };

  let showVerificaDocumentiConfirmationAlert = (transition: Transition, nextPage?: any) => {
    let isConfirmationAlertShown: boolean = false;

    if (!nextPage) {
      verificaDocumentiModalInstantiation('logout', transition);
      isConfirmationAlertShown = true;
    } else {
      if (nextPage.name !== 'home.conservazione-versamento-result') {
        verificaDocumentiModalInstantiation('login', transition, nextPage);
        isConfirmationAlertShown = true;
      }
    }

    return isConfirmationAlertShown;
  };

  $rootScope.confirmNavigationIfIsVerificaDocumentiState = (transition: Transition, nextPage: any) => {
    if (isVerificaDocumentiState() && nextPage.name !== 'home.conservazione-versamento-result' && !$rootScope.accepted) {
      showVerificaDocumentiConfirmationAlert(transition, nextPage);
    }
  };

  let archiviaUploadInProgressModalInstantiation = (state: any, transition?: Transition, nextPage?: any) => {
    if (transition) {
      transition.abort();
    }

    let uploadInProgressModalInstance = $uibModal.open({
      animation: true,
      component: 'defaultModalComponent',
      windowClass: 'center-modal',
      resolve: {
        config: () => {
          return {
            headerIcon: 'fa fa-exclamation-triangle',
            headerText: 'Attenzione',
            bodyHtml: `
                            Alcuni files sono in attesa di essere trasferiti. <br/>
                            Se esci da <span class='bold'>Archivia</span> alcuni di questi potrebbero non essere importati correttamente. <br/><br/>
                            Vuoi rimanere in <span class='bold'>Archivia</span>?`,
            buttons: [
              {
                'id': 1,
                'icon': 'fa fa-times-circle-o',
                'label': 'No'
              },
              {
                'id': 2,
                'icon': 'fa fa-check-circle-o',
                'label': 'Si'
              }
            ]
          };
        }
      }
    });
    uploadInProgressModalInstance.result.then((pressedButtonId: number) => {
      if (pressedButtonId === 2) {
        if (transition) {
          transition.abort();
        }
      } else if (pressedButtonId === 1) {
        $rootScope.archiviaUploadInProgress = false;
        if (nextPage && state === 'logout') {
          $rootScope.signOut();
          return;
        }
        $state.go(nextPage.name);
      }
    });
  };

  // archivia upload in progress
  $rootScope.showArchiviaNavigationConfirmatAlertOnUpload = (transition: Transition, nextPage?: any) => {
    let isConfirmationAlertShown = false;

    if (nextPage) {
      archiviaUploadInProgressModalInstantiation('login', transition, nextPage);
    } else {
      archiviaUploadInProgressModalInstantiation('logout', transition);
    }
    isConfirmationAlertShown = true;
    return isConfirmationAlertShown;
  };

  $transitions.onStart({}, (transition: Transition) => {
    if ($rootScope.archiviaUploadInProgress) {
      $rootScope.showArchiviaNavigationConfirmatAlertOnUpload(transition, transition.$to().self);
    }

    let confirmNavigationAlertShown = $rootScope.showConfirmationAlertIfStep2(transition, transition.$to().self);

    if (confirmNavigationAlertShown) {
      return;
    }

    if ($rootScope.confirmNavigationIfIsVerificaDocumentiState(transition, transition.$to().self)) {
      return;
    }

    // version check
    // da qua viene settato se andare o meno in manutenzione
    ArchiSmallServices.version().then((response: any) => {
      let serverVersion = response.version;
      configuration.archiSmallMaintenance = response.isMaintenance;
      let startDate = response.maintenanceStartDate.trim().split(' ');
      $rootScope.archiSmallMaintenanceStartDate = startDate[0];
      $rootScope.archiSmallMaintenanceStartTime = startDate[1];
      $rootScope.archiSmallMaintenanceEndTime = response.maintenanceEndTime;
      if (configuration.archiSmallMaintenance) {
        $state.go('maintenance');
      } else {
        if (response.showMaintenanceAlert) {
          $rootScope.showMaintenanceAlert = true;
        } else {
          $rootScope.showMaintenanceAlert = false;
        }
        let localVersion = store.get('localVersion');
        if (localVersion === null) {
          store.set('localVersion', serverVersion);
        } else if (serverVersion !== localVersion) {
          let modalInstance = $uibModal.open({
            component: 'defaultModalComponent',
            windowClass: 'center-modal',
            resolve: {
              config: () => {
                return {
                  headerIcon: 'fa fa-exclamation-circle',
                  headerText: 'Attenzione',
                  bodyHtml: `La tua applicazione è stata aggiornata all'ultima versione disponibile. <br/>
                                      Per favore effettua nuovamente la login.`,
                  buttons: [
                    {
                      'id': 1,
                      'icon': 'fa fa-check-circle-o',
                      'label': 'Ok'
                    },
                  ]
                };
              }
            }
          });
          modalInstance.result.then((pressedButtonId) => {
            $rootScope.reloadPage();
          }, () => {
            $rootScope.reloadPage();
          });
        }
      }
    }, (error) => {
      $rootScope.alert('error', error);
      // we reload the page to be sure last version is running
      $rootScope.reloadPage();
    });
    // end version check

    if (store.get('jwt') && jwtHelper.isTokenExpired(store.get('jwt'))) {
      store.remove('jwt');
    }

    if (store.get('registrationJWT') && jwtHelper.isTokenExpired(store.get('registrationJWT'))) {
      store.remove('registrationJWT');
    }

    // authorisationLevel = 0 Requires TO NOT BE Logged
    // authorisationLevel = 1 Requires Login(normal user)
    // authorisationLevel = 2 Requires Login(admin user)
    // console.log(transition.$to().self.data);

    if (transition.$to().self.data && transition.$to().self.data.authorisationLevel !== undefined) {
      if (transition.$to().self.data.authorisationLevel > 0) {

        if (!store.get('jwt')) {
          transition.abort();
          $state.go('login');
        } else {
          // serve per evitare che se noi facciamo modifiche ad un utente mentre è collegato, lui non le veda
          ArchiSmallServices.getUser($rootScope.currentUser().sub)
            .then((response) => {
              $rootScope.user = response;
              store.set('user', response);
            }, (error) => {
              $rootScope.alert('error', error);
            });
          $rootScope.goToSubscriptionExpirationIfExpired(transition, transition.$to().self);
          $rootScope.goToUnsubscriptionSectionIfSubscriptionCancelled(transition, transition.$to().self);
          $rootScope.checkIfCanUseFatturazioneAndConservazione(transition, transition.$to().self);
          $rootScope.checkIfCanUseFatturaPrivati(transition, transition.$to().self);
          $rootScope.verifyIfServiceLevelAgreementIsConfirmed();
          $rootScope.verifyIfCancelSubscriptionRequestIsConfimed();
          if (transition.$to().self.data.authorisationLevel === 2) {
            $rootScope.verifyIfUserIsAdmin(transition);
          }
        }
      } else {
        // serve perché altrimenti si crea un loop si transizioni tra home e manutenzione
        if (!configuration.archiSmallMaintenance) {
          // console.log('dentro if loop',configuration.archiSmallMaintenance);

          if (store.get('jwt')
          ) {
            transition.abort();
            $state.go('home.home-index');
          }
        }
      }
    }
  });

  $transitions.onSuccess({}, () => {
    $anchorScroll();
  });

  $transitions.onError({}, (transition: Transition) => {
    let errorMessage = transition.error().message !== 'undefined' ? transition.error().message : transition;
    if (errorMessage.toString().includes('The transition was ignored') && transition.error().type === 5) {
      return;
    }
    $rootScope.alert('error', errorMessage); // test
  });

  $rootScope.currentUser = () => {
    return store.get('jwt') && jwtHelper.decodeToken(store.get('jwt'));
  };

  $rootScope.userComplete = () => {
    return store.get('user');
  };

  $rootScope.signOut = () => {
    let currentStateIsConservazioneCaricaStep2 = $rootScope.checkIfConservazioneCaricaStep2();

    if (
      currentStateIsConservazioneCaricaStep2 &&
      store.get('conservazioneClasseDocumentale') !== null &&
      store.get('conservazioneClasseDocumentale') !== undefined
    ) {
      $rootScope.showConfirmationAlertIfSettingsExist();
      return;
    }

    if ($rootScope.archiviaUploadInProgress) {
      $rootScope.showArchiviaNavigationConfirmatAlertOnUpload();
      return;
    }

    store.remove('jwt');
    if ($rootScope.subscriptionNotificationWorker !== undefined) {
      $rootScope.subscriptionNotificationWorker.unsubscribe();
      $rootScope.subscriptionNotificationWorker = undefined;
      $rootScope.userNotifications = [];
      $rootScope.ArchiDriveNotificationCount = 0;
    }

    $rootScope.subscriptionCancelled = false;
    $rootScope.subscriptionExpired = false;

    store.remove('user');
    sessionStorage.clear();
    $state.go('login');
  };

  $rootScope.reloadPage = () => {
    window.localStorage.clear();
    location.reload(true);
    $rootScope.subscriptionCancelled = false;
    $rootScope.subscriptionExpired = false;
  };

  $rootScope.showConfirmationAlertIfSettingsExist = (transition: Transition, nextPage?: any) => {
    let isConfirmationAlertShown: boolean = false;

    if (!nextPage) {
      $rootScope.modalInstantiation('logout', transition);
      isConfirmationAlertShown = true;
    } else {
      let isNextPageDifferentFromStep1AndStep2 = $rootScope.checkIfNextPageIsDifferentFromStep1Step2AndStep3(nextPage);

      if (
        isNextPageDifferentFromStep1AndStep2 &&
        store.get('conservazioneClasseDocumentale') !== undefined &&
        store.get('conservazioneClasseDocumentale') !== null
      ) {
        $rootScope.modalInstantiation('login', transition, nextPage);
        isConfirmationAlertShown = true;
      }
    }
    return isConfirmationAlertShown;
  };

  $rootScope.checkIfNextPageIsDifferentFromStep1Step2AndStep3 = (nextPage: any): boolean => {
    return [
      'home.conservazione-carica-documento-registro-contabile-step2',
      'home.conservazione-carica-documento-libro-contabile-step2',
      'home.conservazione-carica-documento-modello-dichiarativo-step2',
      'home.conservazione-carica-documento-modello-versamento-step2',
      'home.conservazione-carica-documento-bollette-step2',
      'home.conservazione-carica-documento-altro-documento-step2',
      'home.conservazione-carica-documento-fattura-passiva-step2',
      'home.conservazione-carica-documento-ddt-attivo-step2',
      'home.conservazione-carica-documento-ddt-passivo-step2',
      'home.conservazione-carica-documento-lul-step2',
      'home.conservazione-carica-documento-step1',
      'home.conservazione-carica-documento-step3',
      'home.conservazione-carica-documento-libro-giornale-step2',
      'home.conservazione-carica-documento-prima-nota-step2',
      'home.conservazione-carica-documento-giornali-schede-magazzino-step2',
      'home.conservazione-carica-documento-libro-inventari-step2',
      'home.conservazione-carica-documento-registro-omaggi-step2',
      'home.conservazione-carica-documento-libro-mastro-step2',
      'home.conservazione-carica-documento-libro-cespiti-step2',
      'home.conservazione-carica-documento-altri-libri-step2',
      'home.conservazione-carica-documento-registro-corrispettivi-iva-step2',
      'home.conservazione-carica-documento-dichiarazioni-fiscali-step2',
      'home.conservazione-carica-documento-ricevute-fiscali-step2',
      'home.conservazione-carica-documento-registro-beni-di-terzi-step2',
      'home.conservazione-carica-documento-registro-unico-iva-step2',
      'home.conservazione-carica-documento-libro-registri-iva-step2',
      'home.conservazione-carica-documento-giornali-schede-magazzino-step2',
      'home.conservazione-carica-documento-registro-riepilogativo-iva-step2',
      'home.conservazione-carica-documento-registro-fatture-acquisto-step2',
      'home.conservazione-carica-documento-registro-fatture-vendita-step2',
      'home.conservazione-carica-documento-altri-registri-step2',
      'home.conservazione-carica-documento-modello-f23-f24-step2',
      'home.conservazione-carica-documento-modello-770-step2',
      'home.conservazione-carica-documento-verbali-verifica-scarto-step2',
      'home.conservazione-carica-documento-nomine-deleghe-conservazione-step2',
      'home.conservazione-carica-documento-schede-cliniche-step2',
      'home.conservazione-carica-documento-ordini-a-fornitore-step2',
      'home.conservazione-carica-documento-ordini-da-cliente-step2',
      'home.conservazione-carica-documento-contratti-a-cliente-step2',
      'home.conservazione-carica-documento-contratti-da-fornitore-step2',
      'home.conservazione-carica-documento-registro-rifiuti-step2',
      'home.conservazione-carica-documento-modello-730-step2',
      'home.conservazione-carica-documento-documenti-bancari-step2',
      'home.conservazione-carica-documento-CM-step2',
      'home.conservazione-carica-documento-CMR-step2',
      'home.conservazione-carica-documento-formulario-identificativo-rifiuti-step2',
      'home.conservazione-carica-documento-dichiarazioni-intento-attive-step2',
      'home.conservazione-carica-documento-dichiarazioni-intento-passive-step2',
      'home.conservazione-carica-documento-documenti-doganali-emessi-step2',
      'home.conservazione-carica-documento-documenti-doganali-ricevuti-step2',
      'home.conservazione-carica-documento-note-spese-e-trasferte-step2',
      'home.conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2',
      'home.conservazione-carica-documento-POD-step2',
      'home.conservazione-carica-documento-bilanci-step2'
    ].indexOf(nextPage.name) === -1;
  };

  $rootScope.modalInstantiation = (state: any, transition?: Transition, nextPage?: any) => {
    if (transition) {
      transition.abort();
    }

    let modalInstance = $uibModal.open({
      animation: true,
      component: 'defaultModalComponent',
      windowClass: 'center-modal',
      resolve: {
        config: () => {
          let _conservazioneClasseDocumentale: string = store.get('conservazioneClasseDocumentale').label;
          return {
            headerIcon: 'fa fa-exclamation-triangle',
            headerText: 'Attenzione',
            bodyHtml: `
                            Desideri interrompere l'operazione di Conservazione ${_conservazioneClasseDocumentale}? <br/>
                            <br/>Attenzione! Interrompendo questa procedura tutti i dati temporanei verranno cancellati.
                            <br/><br/>Se selezioni <b>Si</b>, confermi l'uscita dalla procedura e annulli l'operazione in corso, <b>No</b> per proseguire con la Conservazione.`,
            buttons: [
              {
                'id': 1,
                'icon': 'fa fa-times-circle-o',
                'label': 'No'
              },
              {
                'id': 2,
                'icon': 'fa fa-check-circle-o',
                'label': 'Si'
              }
            ]
          };
        }
      }
    });
    modalInstance.result.then((pressedButtonId: number) => {
      if (pressedButtonId === 1) {
        $rootScope.accepted = false;
        if (transition) {
          transition.abort();
        }
      }
      if (pressedButtonId === 2) {
        $rootScope.accepted = true;

        $rootScope.removeConservazioneSettingsFiles(store.get('conservazioneClasseDocumentale').value);

        $timeout(() => {
          store.remove('conservazioneClasseDocumentale');

          if (typeof nextPage === 'undefined' && state === 'logout') {
            $rootScope.signOut();
            return;
          }
          $state.go(nextPage.name);
        });
      }
    });
  };

  $rootScope.verifyIfServiceLevelAgreementIsConfirmed = () => {
    const user = store.get('user');
    if (user && !user.subscription.serviceLevelAgreementConfirmed && sessionStorage.getItem('serviceLevelAgreementShown') !== 'true') {
      const serviceLevelAgreementModalInstance = $uibModal.open({
        animation: true,
        component: 'serviceLevelAgreementModal',
        size: 'lg',
        windowClass: '',
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });

      serviceLevelAgreementModalInstance.result.then(item => {
        if (item) {
          ArchiSmallServices.confirmServiceLevelAgreement()
            .then(response => {
              store.set('user', response);
            }, error => {
              $rootScope.alert('error', error);
            });
        }
        sessionStorage.setItem('serviceLevelAgreementShown', 'true');
      }, () => {
        // ?
      });
    }
  };

  $rootScope.verifyIfCancelSubscriptionRequestIsConfimed = () => {
    const user = store.get('user') as IUser;
    // console.log(user.subscription, sessionStorage.getItem('cancelSubscriptionShown'));
    if (user && user.subscription.cancellationRequest && sessionStorage.getItem('cancelSubscriptionShown') !== 'true') {
      const cancelSubscriptionModalInstance = $uibModal.open({
        animation: true,
        component: 'cancelSubscriptionModal',
        size: 'lg',
        windowClass: '',
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });

      cancelSubscriptionModalInstance.result.then(item => {
        sessionStorage.setItem('cancelSubscriptionShown', 'true');
      }, () => {
        // ?
      });
    }
  };

  $rootScope.verifyIfUserIsAdmin = (transition: Transition) => {
    const user = store.get('user');
    if (!user.isAdmin) {
      transition.abort();
      $state.go('home.home-index');
    }
  };
};

appRun.$inject = [
  '$rootScope',
  '$state',
  '$stateParams',
  'store',
  'jwtHelper',
  'ArchiSmallServices',
  'configuration',
  '$uibModal',
  '$timeout',
  '$anchorScroll',
  '$transitions',
  '$trace'
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/app.run.ts